import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Mail, Phone, MapPin } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
    const c = useContent();
    const f = c.footer || {};

    return (
        <footer className="bg-gray-900 text-white" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <Logo variant="dark" className="h-14 mb-8" />
                    <p className="text-gray-400 text-sm leading-relaxed max-w-md">
                        {f.description}
                    </p>
                </div>

                <div className="md:col-span-3">
                    <div className="overline text-red-600 mb-5">{f.catalog_heading || "Catalog"}</div>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/products?category=thermos-flask-production-lines" className="hover:text-red-600 transition-colors" data-testid="footer-cat-flask">Thermos &amp; Flask Lines</Link></li>
                        <li><Link to="/products?category=cup-printing-machines" className="hover:text-red-600 transition-colors" data-testid="footer-cat-print">Cup Printing Machines</Link></li>
                        <li><Link to="/products" className="hover:text-red-600 transition-colors" data-testid="footer-all-products">All Machinery</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <div className="overline text-red-600 mb-5">{f.company_heading || "Company"}</div>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/about" className="hover:text-red-600 transition-colors">About</Link></li>
                        <li><Link to="/contact" className="hover:text-red-600 transition-colors">Contact</Link></li>
                        <li><Link to="/admin/login" className="hover:text-red-600 transition-colors" data-testid="footer-admin-link">Admin</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <div className="overline text-red-600 mb-5">{f.contact_heading || "Contact"}</div>
                    <ul className="space-y-3 text-sm text-gray-300">
                        <li className="flex items-start gap-2"><Mail size={14} className="mt-1 shrink-0" /><span>{f.email}</span></li>
                        <li className="flex items-start gap-2"><Phone size={14} className="mt-1 shrink-0" /><span>{f.phone}</span></li>
                        <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 shrink-0" /><span>{f.location}</span></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-gray-500 font-mono uppercase tracking-[0.2em]">
                    <div>© {new Date().getFullYear()} Back At One</div>
                    <div>{f.copyright_tagline}</div>
                </div>
            </div>
        </footer>
    );
};
